import { Modal } from "../theme/modal/modal";
import { lock, unlock } from "tua-body-scroll-lock";

export interface IAccountOverlay extends HTMLElement {
  toggleAccountOverlay(): void;
  showAccountOverlay(): void;
  hideAccountOverlay(): void;
}

class AccountOverlay extends Modal implements IAccountOverlay {
  constructor() {
    super();
  }

  connectedCallback() {
    this.setEventListeners();
    super.connectedCallback();
  }

  private setEventListeners() {
    document.addEventListener("modal:show", (event: Event) => {
      const customEvent = event as CustomEvent;
      const modalName = customEvent.detail.modalName;

      if (modalName === "account-overlay") {
        return;
      }

      this.hideAccountOverlay();
    });

    document.addEventListener("modal:closed:account-overlay", () => {
      this.hideAccountOverlay();
    });

    document.addEventListener("predictive-search:visible", () =>
      this.hideAccountOverlay(false),
    );
  }

  private closeDesktopNavigation() {
    const desktopMenu = document.querySelector("uwp-desktop-menu") as any;
    if (desktopMenu?.closeAllDropdowns) {
      desktopMenu.closeAllDropdowns();
    }
  }

  public toggleButtonActiveClass() {
    const accountOverlayButton = document.querySelector(
      "[js-header='accountOverlay']",
    );

    this.isAccountOverlayShowing()
      ? accountOverlayButton?.classList.add("is-open")
      : accountOverlayButton?.classList.remove("is-open");
  }

  public toggleAccountOverlay(): void {
    this.isAccountOverlayShowing()
      ? this.hideAccountOverlay()
      : this.showAccountOverlay();
  }

  private isAccountOverlayShowing(): boolean {
    return this.classList.contains("is-open");
  }

  public showAccountOverlay(): void {
    // Close any other open modals/drawers before opening account overlay
    const openModals = document.querySelectorAll(
      ".modal.is-open, .drawer.is-open, .search-input--desktop.is-active",
    );
    openModals.forEach((modal) => {
      if (
        modal.classList.contains("modal") ||
        modal.classList.contains("drawer")
      ) {
        const hideMethod =
          (modal as any).hideModal || (modal as any).hideDrawer;
        if (hideMethod) {
          hideMethod.call(modal);
        }
      }
    });

    super.showModal();
    this.closeDesktopNavigation();

    // Ensure scroll lock for account overlay
    lock(this);

    // Apply styles if header is transparent
    const header = document.querySelector(
      ".header-background, .header-background-transparent",
    );
    // Targeting account-overlay__list for styles
    const listElement = this.querySelector(
      ".account-overlay__list",
    ) as HTMLElement | null;

    if (
      listElement &&
      header &&
      header.classList.contains("header-background-transparent")
    ) {
      listElement.style.borderRadius = "8px";
      listElement.style.overflow = "hidden";
      listElement.style.paddingTop = "32px";
    } else if (listElement) {
      listElement.style.borderRadius = ""; // Reset to SCSS defined 0 0 8px 8px or initial if not set
      listElement.style.overflow = "";
      listElement.style.paddingTop = ""; // Reset to SCSS defined padding or initial if not set
    }
  }

  public hideAccountOverlay(restoreFocus = true): void {
    if (!this.isAccountOverlayShowing()) {
      return;
    }

    // Reset styles on listElement when overlay is hidden
    // Targeting account-overlay__list for styles
    const listElement = this.querySelector(
      ".account-overlay__list",
    ) as HTMLElement | null;
    if (listElement) {
      listElement.style.borderRadius = "";
      listElement.style.overflow = "";
      listElement.style.paddingTop = "";
    }

    super.hideModal(restoreFocus);

    // Ensure scroll unlock for account overlay
    unlock(this);
  }
}

customElements.define("uwp-account-overlay", AccountOverlay);
